export class SyncFactory {
  public static getPath(): string {
    return 'sync';
  }
}
